<template>
  <div class="check-icon" ref="check-icon">
    <svg
      width="12px"
      height="12px"
      viewBox="0 0 22 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g id="Final-User-Portal" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g
          id="CC-Contribution-Monthly"
          transform="translate(-277.000000, -587.000000)"
          stroke="#979797"
          stroke-width="2"
        >
          <g id="Group-4" transform="translate(278.000000, 588.000000)">
            <path
              d="M3.75022608,17.8319177 C4.66439325,18.6357027 5.6009088,19.2127119 6.55977273,19.5629454 C8.39642801,20 8.39642801,20 10,20 C16.4571914,20 20,15.5228475 20,10 C20,6.80058085 18.4974876,3.95209227 16.1595811,2.12165262 C14.4617861,0.792381544 12.3234283,0 10,0 C4.4771525,0 0,4.4771525 0,10"
              id="Oval"
              transform="translate(10.000000, 10.000000) rotate(180.000000) translate(-10.000000, -10.000000) "
            ></path>
            <polyline
              id="Line-4"
              stroke-linecap="square"
              points="6 10.4360792 9.22584597 14.3344751 18.4307134 5"
            ></polyline>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'CheckIcon',
  components: {},
  data() {
    return {}
  },
  methods: {},
  computed: {},
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
.check-icon {
}
g {
  stroke: var(--dark-brand-color);
}
</style>
